import NoPhotoIcon from "assets/images/user.svg";
import { countryName } from "common/country";
import { varIs } from "common/var";
import { useSelector } from "react-redux";
import { asDate, asVolume } from "utils/text";
import { Wrapper } from "./DetailBox.styled";

export default function DetailBox(props) {
  const isOpenedDetailBox = useSelector(
    (state) => state.binaryTree.isOpenedDetailBox
  );
  const detailBoxPosition = useSelector(
    (state) => state.binaryTree.detailBoxPosition
  );
  const detailData = useSelector((state) => state.binaryTree.detailData);
  const treeType = useSelector((state) => state.binaryTree.treeType);

  if (!isOpenedDetailBox) return "";

  return (
    <Wrapper
      style={{
        left: detailBoxPosition.left || 0,
        top: detailBoxPosition.top || 0,
      }}
    >
      <div className={"headerBar"}>
        <div className="userImage">
          <img className={"photo"} src={detailData.image || NoPhotoIcon} />
          <div className="userStatus active" />
        </div>
        <div>
          <p className={"name"}>
            {`${detailData.first_name} ${detailData.last_name}`}
          </p>
          <p className={"userLink"}>{`#${detailData.uuid}`}</p>
        </div>
      </div>
      <div style={{ padding: "16px 12px", borderTop: "1px solid #f0f0f0" }}>
        <table>
          <tbody>
            {varIs("user.type", detailData.type, "affiliate") &&
              treeType === "unilevel" && (
                <>
                  <tr>
                    <td>Paid Promoter Rank</td>
                    <td align={"right"}>{detailData.pay_rank?.name}</td>
                  </tr>
                  <tr>
                    <td>Paid Builder Rank</td>
                    <td align={"right"}>{detailData.pay_builder_rank?.name}</td>
                  </tr>
                </>
              )}
            <tr>
              <td>Country</td>
              <td align={"right"}>{countryName(detailData.country)}</td>
            </tr>
            {treeType === "unilevel" && (
              <tr>
                <td>Enroller</td>
                <td align={"right"}>{detailData.enroller?.username}</td>
              </tr>
            )}
            {treeType === "placement" && (
              <tr>
                <td>Parent</td>
                <td align={"right"}>{detailData.parent?.username}</td>
              </tr>
            )}
            <tr>
              <td>Subscription</td>
              <td align={"right"}>
                {detailData.subscription_count * 1 > 0 ? (
                  <span className="subscription-yes">Yes</span>
                ) : (
                  <span className="subscription-no">No</span>
                )}
              </td>
            </tr>
            <tr>
              <td>Marketer Points</td>
              <td align={"right"}>{asVolume(detailData.qualification.mp)}</td>
            </tr>
            <tr>
              <td>Activity Points</td>
              <td align={"right"}>{asVolume(detailData.qualification.ap)}</td>
            </tr>
            <tr>
              <td>Organization Points</td>
              <td align={"right"}>{asVolume(detailData.qualification.op)}</td>
            </tr>
            <tr>
              <td>Enroller Organization Points</td>
              <td align={"right"}>{asVolume(detailData.qualification.eop)}</td>
            </tr>
            <tr>
              <td>Join Date</td>
              <td align={"right"}>{asDate(detailData.created_at)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Wrapper>
  );
}
